import { c as _c } from "react/compiler-runtime";
import { useEffect, useRef } from 'react';
import { useIsVisible } from '@sbt-web/hooks';
import { useCalendar } from '../hooks/useCertyWidget';
import styles from './index.module.scss';
const observerOptions = {
  threshold: 0.01
};
export const CertyWidget = () => {
  const $ = _c(10);
  const {
    handleCalendar
  } = useCalendar();
  const ref = useRef(null);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = {
      observerOptions
    };
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const [isVisible, setElement, unobserve] = useIsVisible(t0);
  let t1;
  let t2;
  if ($[1] !== handleCalendar || $[2] !== isVisible) {
    t1 = () => {
      if (isVisible) {
        handleCalendar();
      }
    };
    t2 = [isVisible, handleCalendar];
    $[1] = handleCalendar;
    $[2] = isVisible;
    $[3] = t1;
    $[4] = t2;
  } else {
    t1 = $[3];
    t2 = $[4];
  }
  useEffect(t1, t2);
  let t3;
  let t4;
  if ($[5] !== setElement || $[6] !== unobserve) {
    t3 = () => {
      if (ref.current) {
        setElement(ref.current);
      }
      return () => unobserve();
    };
    t4 = [setElement, unobserve];
    $[5] = setElement;
    $[6] = unobserve;
    $[7] = t3;
    $[8] = t4;
  } else {
    t3 = $[7];
    t4 = $[8];
  }
  useEffect(t3, t4);
  let t5;
  if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <div ref={ref} id="myCalendar" className={styles.wrapper} />;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  return t5;
};